import React from 'react';
import { ExternalLink } from 'lucide-react';

const Experience = () => {
  const projects = [
    {
      image: '/ceasefire-project.png',
      url: 'http://bit.ly/ceasefireproject',
      alt: 'Ceasefire Project - World Peace Movement'
    },
    {
      image: '/hermetix-project.png',
      url: 'http://bit.ly/HermetixAIexplained',
      alt: 'Hermetix.ai - AI for Consciousness'
    },
    {
      image: '/great-discovery-project.png',
      url: 'http://bit.ly/JoinSkillMedia',
      alt: 'The Great Discovery - Global Education'
    },
    {
      image: '/space-race-family-project.png',
      url: 'http://bit.ly/boomzooom',
      alt: 'World Peace Now - Space Race Family Movement'
    }
  ];

  return (
    <section id="experience" className="py-24 bg-gradient-to-b from-black to-[#0B1D2A] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-1/4 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Professional <span className="text-[#D4AF37]">Journey</span>
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto rounded-full mb-6" />
          <p
            className="text-lg text-white/70 max-w-2xl mx-auto"
            style={{ fontFamily: 'Lato, sans-serif' }}
          >
            Three decades of transformational leadership and global impact
          </p>
        </div>

        {/* Leadership Image Banner */}
        <div className="mb-16">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="/contemplative-charles.png"
              alt="Charles Crawshaw - Leadership"
              className="w-full h-64 md:h-80 object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent flex items-center">
              <div className="px-8 md:px-12">
                <h3
                  className="text-3xl md:text-4xl font-bold text-white mb-2"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  30+ Years of Transformational Leadership
                </h3>
                <p
                  className="text-lg text-white/90"
                  style={{ fontFamily: 'Lato, sans-serif' }}
                >
                  From Landmark Worldwide to global AI innovation
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Project Image Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              onClick={() => window.open(project.url, '_blank', 'noopener,noreferrer')}
              className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-2xl hover:shadow-[#D4AF37]/20 transition-all duration-500 hover:scale-105"
            >
              {/* Project Image */}
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={project.image}
                  alt={project.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                
                {/* Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                {/* External Link Icon */}
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-[#D4AF37] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110 shadow-lg">
                  <ExternalLink className="w-5 h-5 text-black" />
                </div>
              </div>

              {/* Border Glow Effect */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#D4AF37] transition-colors duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
